import logo from "./logo.svg";
import "./App.css";
import MainRoutes from "./routes/MainRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { AppUserProvider } from "./contexts/AppUserContext";

function App() {
  return (
    <AppUserProvider>
      <MainRoutes />
    </AppUserProvider>
  );
}

export default App;
